/**
 * schema-reader — lightweight accessor over a normalised ProductSchema object.
 *
 * The schema is now fetched at runtime (see schema-fetch.js) rather than parsed
 * from a Liquid-emitted JSON sidecar. This module just wraps the object with
 * convenience lookups used by the component and renderer.
 */

/**
 * @param {object} schema  normalised schema (from normalizeSchema)
 * @returns {{
 *   raw: object,
 *   option(name: string): object|null,
 *   value(name: string, rawValue: string): object|null,
 *   displayLabel(name: string, rawValue: string): string,
 *   variant(id: string|number): object|null
 * }}
 */
export function makeAccessor(schema) {
  return {
    raw: schema,
    option(name) {
      return schema.options.find((o) => o.name === name) ?? null;
    },
    value(name, rawValue) {
      const opt = schema.options.find((o) => o.name === name);
      return opt?.values.find((v) => v.rawValue === rawValue) ?? null;
    },
    displayLabel(name, rawValue) {
      return this.value(name, rawValue)?.displayLabel ?? rawValue;
    },
    variant(id) {
      const sid = String(id);
      return schema.variants.find((v) => String(v.id) === sid) ?? null;
    },
  };
}
